<nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
    <a class="navbar-brand mr-lg-5" href="../index.html">
        <img class="navbar-brand-dark" src="../volt_1.2/assets/img/brand/light.svg" alt="Volt logo" /> <img class="navbar-brand-light" src="../volt_1.2/assets/img/brand/dark.svg" alt="Volt logo" />
    </a>
    <div class="d-flex align-items-center">
        <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>

<SideBarMenu currentPage='Templates'></SideBarMenu>

<main class="content">

    <TopBarNav></TopBarNav>

<!--
            <div class="preloader bg-soft flex-column justify-content-center align-items-center">
    <img class="loader-element animate__animated animate__jackInTheBox" src="../volt_1.2/assets/img/brand/light.svg" height="60" alt="Volt logo">
</div>
-->

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                          <li class="breadcrumb-item"><a href="/#/"><span class="fas fa-home"></span></a></li>
                          <li class="breadcrumb-item"><a href="/#/templates">Templates</a></li>
                          <li class="breadcrumb-item active" aria-current="page">{template.name}</li>
                        </ol>
                    </nav>
                    <h2 class="h4">Template {template.name}</h2>
                    <p class="mb-0">Your web analytics dashboard template.</p>
                </div>
            </div>

            {#if message.level}
            <div class="alert alert-{message.level}" role="alert">
                {message.text}
            </div>
            {/if}

            <div class="card card-body border-light shadow-sm table-wrapper table-responsive">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="template_name" class="form-label">Name</label>
                        <input type="text" class="form-control" id="template_name" placeholder="An unique name" bind:value={template.name}>
                    </div>
                    <div class="col-md-4 mt-auto">
                        private
                    </div>
                    <div class="col-md-4 mt-auto">
                        <button class="btn btn-primary" on:click={saveTemplate}>Save</button>
                        <button class="btn btn-danger" on:click={deleteTemplate}>Remove</button>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="template_" class="form-label">HTML code</label>
                    <textarea class="form-control" id="template_html" rows="25" bind:value={template.html}></textarea>
                </div>
            </div>
            
    <BottomFooter></BottomFooter>
</main>


<script>
    import {format as dtfns_format, formatISO9075, parseISO} from 'date-fns'
    import {push} from 'svelte-spa-router'

    import {DBC_URL, stLang} from '../store.js'
    import {axiosPost} from '../c0utils.js'

    import {stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'

    import BottomFooter from '../comp/BottomFooter.svelte'
    import SideBarMenu from '../comp/SideBarMenu.svelte'
    import TopBarNav from '../comp/TopBarNav.svelte'

    export let params = {}

    console.log('LANG: ', $stApp.user.settings.lang)
    const t = $stLang[$stApp.user.settings.lang]

    if(params.uid) {
        requestTemplate(params.uid)
    }
    else {
        requestTemplate(null)
    }

    console.log("params", params.uid)

    let template = {
        ts_created: '',
        ts_updated: '',
        name: '',
        uid: params.uid,
        html: ''
    }

    const message = {
        level: '',
        text: ''
    }

    function requestTemplate(uid) {
        axiosPost(DBC_URL + '/template', {
            TEMPLATE: { uid }
        })
        .then((result) => {
            if(result.ok) template = result.data
        })
    }

    function saveTemplate() {
        axiosPost(DBC_URL + '/template/save', {
            TEMPLATE: template
        })
        .then((result) => {
            if(result.ok) { message.level = 'success'; message.text = result.msg }
            else { message.level = 'danger'; message.text = result.msg }
        })
    }

    function deleteTemplate() {
        axiosPost(DBC_URL + '/template/delete', {
            TEMPLATE: template
        })
        .then((result) => {
            if(result.ok) {
                $stApp.msgs.push({level: 'success', text: t[result.msg]})
                console.log("MSGS: ", $stApp.msgs)
                push('/templates')
            }
            else { message.level = 'danger'; message.text = result.msg }
        })
    }

    function logout() {
        $stApp.user = {}
        push('/')
    }


</script>
